<template>
  <div>
    <v-row>
      <v-switch
        v-model="conditionValue.hasFilter"
        :disabled="isDisabled"
        class="mx-3 mb-6"
        label="Filtres"
        color="success"
        hide-details
      />
    </v-row>
    <div v-if="conditionValue.hasFilter">
      <!-- filters iteration -->
      <div v-for="(filterValue, index) in conditionValue.filters" :key="filterValue.facet">
        <!-- btn remove -->
        <div class="float-right mt-6 mr-9">
          <v-btn icon @click="removeFilter(index)">
            <v-icon>close</v-icon>
          </v-btn>
        </div>

        <!-- filters fields -->
        <FiltersFieldItem v-model="conditionValue.filters[index]" :unavailable-facets="unavailableFacets" />
      </div>

      <!-- add button -->
      <div v-if="conditionValue.hasFilter" class="mx-4">
        <v-btn icon @click="addFilter()">
          <v-icon>add</v-icon> add
        </v-btn>
      </div>

      <!-- RULE TO HAVE A MINIM 1 RULE -->
      <v-text-field v-show="false" v-model="conditionValue.filters" :rules="[v => v.length > 0 || 'Required']" />
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch, computed, onMounted } from 'vue';
import FiltersFieldItem from './FiltersFieldItem.vue';

const props = defineProps({ condition: { type: Object, default: null }, isDisabled: { type: Boolean, default: false } });
const emit = defineEmits('update:condition');

const conditionValue = ref(props.condition);

const unavailableFacets = computed(() => conditionValue.value.filters.map(value => value.facet));

const addFilter = () => {
  conditionValue.value.filters.push({ facet: null, values: [] });
};

const removeFilter = index => {
  conditionValue.value.filters.splice(index, 1);
};

watch(
  () => conditionValue.value,
  () => {
    // Updates v-model on the parent
    emit('update:condition', conditionValue.value);
  },
  { deep: true }
);

onMounted(() => {
  if (conditionValue.value.filters.length === 0) {
    addFilter();
  }
});

</script>

<style>
</style>
